import "./DownloadExport.css";

import { Button } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import React from "react";
import { exportToExcel } from "../../../api/excel";

function DownloadExport({ data, fileName, type, size="small" }) {
  return (
    <div className="downloadExport__container">
      <Button
        onClick={() => exportToExcel(data, fileName, type)}
        variant="outlined"
        startIcon={<GetAppIcon />}
        size={size}
      >
        Export
      </Button>
    </div>
  );
}

export default DownloadExport;
